export default __webpack_public_path__ + "static/media/PartnerSolutions_old.9753bf87.jpeg";